export default {
	allLeagues(state) {
		return state.leagues
	},
	allSchedules(state) {
		return state.schedules
	},
	allDivisions(state) {
		return state.divisions
	}
};
